export const zh_CHS = {
    static: {
        taskActions: {
            pass: '通过',
            back: '驳回',
            refuse: '否决',
            more: '更多',
            viewLog: '审批日志',
            viewFlowChart: '查看流程',
            viewBizlog: '审批日志'
        },
        assignee: {
            title: '请选择用户',
            cancelAssign: '已取消操作。',
            noAssignee: '请至少选择一个审批人。',
            successAssign: '操作成功。',
            errorAssign: '操作失败，请联系管理员查看原因！'
        },
        addsign: {
            title: '请选择用户',
            selectConsultant: '请选择用户。',
            successConsult: '征询成功。',
            cancelSignUp: '已取消。'
        },
        transfer: {
            title: '请选择用户',
            selectHandover: '请选择用户。',
            successTransfer: '任务移交成功。'
        },
        columnName: {
            name: '名称',
            code: '编号',
            department: '组织信息',
            organization: '组织',
            prcessName: '流程名称',
            version: '版本'
        },
        common: {
            placeHolder: '请输入'
        },
        submit: {
            selectProcess: '选择流程',
            noProcess: '请选择流程'
        },
        title: '审批确认',
        inputLabel: '审批意见',
        inputHolder: '请输入审批意见',
        selectActivity: '目标节点',
        addSignee: '加签人员',
        footOk: '确定',
        footCancel: '取消',
    },
    cueWords: {
        successClaim: '领用成功。',
        successUnClaim: '取消领用成功。',
        successRetrieve: '任务取回成功。',
        successPass: '审批通过。',
        successBack: '驳回成功。',
        successRefuse: '否决成功。',
        success: '操作成功'
    }
};
